import { useState } from 'react'
import { useSubscription } from '@refinedev/core'

import { PLATFORM_LIVE_CHANNELS } from '@/lib/platform-live-channels'
import { LIVE_CONNECTION_EVENTS } from '@/providers/live-provider'

/** Whether the Refine live provider currently has an open realtime connection. */
export function useLiveConnected(): boolean {
	const [connected, setConnected] = useState(false)

	useSubscription({
		channel: PLATFORM_LIVE_CHANNELS.CONNECTION,
		types: ['*'],
		onLiveEvent: (event) => {
			setConnected(event.type === LIVE_CONNECTION_EVENTS.CONNECTED)
		},
	})

	return connected
}
